import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { AdalapiService } from './adalapi.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { environment } from 'src/environments/environment';
import { SecureStorageService } from './secure-storage.service';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  url: string;
  accessToken: any;
  token_type: any;
  token: string;
  tokenCheck = new BehaviorSubject<any>(false);
  tokenCheckFlag = this.tokenCheck.asObservable();
  parkDropDownDetails = new BehaviorSubject<any>([]);
  parkDropDownDetailsArray = this.parkDropDownDetails.asObservable();

  constructor(
    private apiService: ApiService,
    private adalapiService: AdalapiService,
    private secureStorage: SecureStorageService
  ) { }

  getauthorizationToken(token): Observable<any> {
    this.url = APIs.getAuthToken;
    const header = {
      Authorization: token,
    };
    const paramObj = {
      client_id: environment.officeRndClientId,
      client_secret: environment.officeRndClientSecret,
      grant_type: 'client_credentials',
      scope: 'officernd.api.read officernd.api.write',
    };
    return this.apiService.get(this.url, paramObj, header).pipe(
      map((response) => {
        return response;
      })
    );
  }
  getApiauthorizationToken(): Observable<any> {
    this.url = APIs.getApiAuthToken;
    const paramObj = {
      email: 'ASAs',
      Password: 'Test',
    };
    return this.apiService.get(this.url, paramObj).pipe(
      map((response) => {
        return response.data;
      })
    );
  }

  getAdminToken(email): Observable<any> {
    this.url = APIs.getAdminDetails;
    const paramObj = {
      Email: btoa(email),
      //"subscription-key":"b6831e2b-ab74-417e-92f5-d0e26657abdc"
    };
    return this.apiService.get(this.url, paramObj).pipe(
      map((response) => {
        // console.log(response.list[0].userDetails);
        response.list[0].userDetails.TokenDetails[0].token = 'aaa';
        if (response.list[0].userDetails.TokenDetails[1]) {
          response.list[0].userDetails.TokenDetails[1].token = 'bbb';
        }
        this.secureStorage.setItem('Tokens', JSON.stringify(response.list[0]['userDetails']['TokenDetails']));
        return response;
      })
    );
  }

  getAdminTokenInOverviewPage(email): Observable<any> {
    this.url = APIs.getAdminDetailsWithToken;
    const paramObj = {
      Email: email,
    };
    return this.apiService.get(this.url, paramObj).pipe(
      map((response) => {
        this.secureStorage.setItem('Tokens', JSON.stringify(response.list));
        return response;
      })
    );
  }

  // logoutToken(): Observable<boolean> {
  //   const paramObj = {
  //     token: localStorage.getItem(AppConstant.localStorage.token),
  //   };
  //   return this.apiService
  //     .post(
  //       APIs.logoutToken +
  //       '/?token=' +
  //       localStorage.getItem(AppConstant.localStorage.token),
  //       null
  //     )
  //     .pipe(
  //       map((response) => {
  //         return response.isValid;
  //       })
  //     );
  // }

  logoutToken(): Observable<boolean> {
    const paramObj = {
      token: this.secureStorage.getItem(AppConstant.localStorage.token),
    };
    return this.apiService
      .post(APIs.logoutToken, paramObj, null)
      .pipe(
        map((response) => {
          return response.isValid;
        })
      );
  }

  // logoutToken(): Observable<boolean> {
  //   const paramObj = {
  //     token: localStorage.getItem(AppConstant.localStorage.token),
  //   };
  //   return this.apiService
  //     .post(APIs.logoutToken, paramObj, null)
  //     .pipe(
  //       map((response) => {
  //         return response.isValid;
  //       })
  //     );
  // }

  getContracts(teamId: string) {
    const paramObj = {
      client_id: environment.officeRndClientId,
      client_secret: environment.officeRndClientSecret,
      grant_type: 'client_credentials',
      scope: 'officernd.api.read officernd.api.write',
    };
    return this.apiService.get(APIs.getAuthToken, paramObj).pipe(
      switchMap((r) => {
        return this.apiService
          .get(
            APIs.getOfficeContracts,
            { Authorization: r.access_token, team: teamId },
            { Authorization: r.access_token }
          )
          .pipe(
            map((response) => {
              return response;
            })
          );
      })
    );
  }

  setTokenAfterSelection(response) {
    this.secureStorage.setItem(AppConstant.localStorage.token, response.token);
    this.secureStorage.setItem(AppConstant.localStorage.claId, response.claId);
    this.secureStorage.setItem(AppConstant.localStorage.isAdmin, response.isAdmin);
    this.secureStorage.setItem(AppConstant.localStorage.claAdminId, response.claAdminId);
    this.secureStorage.setItem(AppConstant.localStorage.userType, response.userType);
    this.tokenCheck.next(true);
  }

  setTokenAfterSelectionForOverViewPage(response) {
    this.secureStorage.setItem(AppConstant.localStorage.token, response.token);
    this.tokenCheck.next(true);
  }

  getParkByCLAId() {
    const claAdminId = this.secureStorage.getItem('claAdminId');
    if (claAdminId != null && claAdminId != '' && claAdminId != 'null') {
      return this.apiService
        .get(`${APIs.getParkByClaId}?claId=${claAdminId}`)
        .pipe(
          map((response) => {
            if (response.isValid) {
              this.parkDropDownDetails.next(response.list);
              // console.log(response.list);
            }
            return response;
          })
        );
    }
  }

  getParkDropDownDetails(): Observable<any> {
    return this.parkDropDownDetails.asObservable();
  }

  changePassword(body): Observable<any> {
    return this.apiService.post(APIs.changeSecuirtyPassword, body).pipe(
      map((response) => {
        return response;
      })
    );
  }

  verifyEmailForApp(body) {
    return this.apiService
      .post(APIs.verifyEmailForApp + '/?emailid=' + body)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getProfileDetail(data) {
    return this.apiService.get(APIs.getProfileDetail, data).pipe(
      map((response) => {
        return response?.data;
      })
    );
  }

  getAdminTokenAdalAuth(token): Observable<any> {
    this.url = APIs.getAdminDetails;
    const paramObj = {
      token: token,
      //"subscription-key":"b6831e2b-ab74-417e-92f5-d0e26657abdc"
    };
    return this.adalapiService.get(this.url).pipe(
      map((response) => {
        if (response.isValid === true) {
          this.secureStorage.setItem('Tokens', JSON.stringify(response.list[0]['userDetails']['TokenDetails']));
          return response;
        } else {
          this.secureStorage.clear();
          this.logoutFromCla();
        }
      })
    );
  }

  logoutFromCla() {
    setTimeout(() => {
      this.logoutFromAd();
    }, 1000);
  }

  logoutFromAd(popup?: boolean) {
    window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURI(environment.domain)}`
  }
}
